module.exports = __webpack_public_path__ + "static/media/smile-beam.459e5b7b.svg";